export enum CompanyVerificationStatus {
  Unverified = 0,
  Pending = 1,
  Verified = 2,
  Rejected = 3,
}

export interface CompanyAdmin {
  id: string;
  email: string;
  firstName?: string;
  lastName?: string;
  companyName?: string;
  gstHstNumber?: string;
  zip?: string;
  phone?: string;
  verificationStatus: CompanyVerificationStatus;
  verificationNotes?: string;
  verifiedAt?: string;
}
